import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { Clipboard } from '@angular/cdk/clipboard';

@Component({
  selector: 'app-api-secret-popup',
  templateUrl: './api-secret-popup.component.html',
  styleUrls: ['./api-secret-popup.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ApiSecretPopupComponent {
  readonly data = inject(MAT_DIALOG_DATA);
  private clipboard = inject(Clipboard);

  readonly dialogRef = inject(MatDialogRef<ApiSecretPopupComponent>);

  private toastr = inject(ToastrService);

  copySecret(secret: string): void {
    if (this.clipboard.copy(secret)) {
      this.toastr.success('Secret copied successfully.');
    } else {
      this.toastr.error('Failed to copy secret.');
    }
  }
}
